const wixFormattingCreator = require('@wix/wix-code-formatting')

module.exports = (value, { format, wixSdk, fieldType }) => {
  if (!format || format.type !== fieldType) {
    return value
  }

  const wixFormatting = wixFormattingCreator({ locale: wixSdk.window.locale })
  return wixFormatting.formatDateTime(new Date(value), format.params.dateFormat)
}
